import { ExperienceStateBadge } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function ExperienceStateBadgeDemo() {
  return (
    <Section
      id="experience-state-badge"
      title="ExperienceStateBadge"
      description="Lifecycle chip for an AI Experience. Completes the badge family next to ExperienceTypeBadge + VisibilityBadge. Tokenised tones; getExperienceStateMeta exported for labels."
    >
      <VariantBlock label="States">
        <ExperienceStateBadge state="draft" />
        <ExperienceStateBadge state="in_progress" />
        <ExperienceStateBadge state="ready_to_publish" />
        <ExperienceStateBadge state="published" />
        <ExperienceStateBadge state="archived" />
      </VariantBlock>

      <VariantBlock label="Sizes">
        <ExperienceStateBadge state="published" size="sm" />
        <ExperienceStateBadge state="published" size="md" />
      </VariantBlock>

      <VariantBlock label="Unknown state" caption="humanised fallback">
        <ExperienceStateBadge state="in_review" />
        <ExperienceStateBadge state="pending_approval" />
      </VariantBlock>
    </Section>
  );
}
